/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { Fragment, useCallback, useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import { IMaskInput } from "react-imask";
import { emailMask } from "utils/inputMask";
import debounce from "lodash.debounce";
import { SettingsFormatEdit } from "cms/fields/layout/controls/settings-format";
import { SettingsStyleEdit } from "cms/fields/layout/controls/settings-style";
import useStyles from "cms/fields/_styles";
import { useSelectFieldSchema } from "cms/fields/hooks/use-select-field-schema";
import { DisplaySettingsWrapper } from "cms/fields/layout/display-settings-wrapper";
import { ListItemContext } from "cms/fields/field-lists/field-list-context";
// import useThrottle from 'hooks/useThrottle'

const EmailFieldItemEdit = () => {
    
    const { t } = useTranslation();
    // const throttler = useThrottle()
    const classes = useStyles();

    const ctx = useContext(ListItemContext);
    const { type, name, index, value, settings, updateListItem, disabled = false } = ctx;

    const schema = useSelectFieldSchema(name);
    const { settings: schemaSettings } = schema || {};
    const { styleOptions, formatOptions, placeholder } = schemaSettings || {};
    const ph = placeholder || t("commons.placeholderText");
    
    const initialState = {
        value: value ? value : "",
        settings
    };
    const [itemLocalState, setItemLocalState] = useState(initialState);

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const update = useCallback(
        debounce((updateState, index) => {
            updateListItem(updateState, index);
        }, 500),
        [updateListItem]
    );
    
    const onSettingsChange = (updateState) => {
        setItemLocalState(updateState);
        update(updateState, index);
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const onChange = useCallback(
        debounce((value) => {
            const newState = { ...itemLocalState, value: value };
            setItemLocalState(newState);
            updateListItem(newState, index);
        }, 1200),
        [update, setItemLocalState]
    );
    
    return (
        <Fragment>
            <div className='simplicity-composer-field-primary-layout'>
                <div className='simplicity-composer-field-primary'>
                    {/*  FIXME: This is not working  */}
                    <IMaskInput
                        mask={emailMask}
                        className={`question-iMask-input ${disabled ? classes.disabled : ""}`}
                        fullwidth='true'
                        placeholder={ph}
                        name={name}
                        value={itemLocalState?.value}
                        onAccept={onChange}
                    />
                </div>
                <DisplaySettingsWrapper>
                    {/*  Reads from schema options.styleOptions */}
                    {/*  records selection as value settings.style */}
                    <SettingsStyleEdit
                        type={type}
                        name={name}
                        label={t("commons.displayStyle")}
                        itemLocalState={itemLocalState}
                        setItemLocalState={setItemLocalState}
                        disabled={disabled}
                        styleOptions={styleOptions}
                        selected={itemLocalState?.settings?.style}
                        index={index}
                        update={onSettingsChange}
                    />
                    {/*  Reads from schema options.formatOptions */}
                    {/*  records selection as value settings.format */}
                    <SettingsFormatEdit
                        type={type}
                        name={name}
                        label={t("commons.displayAs")}
                        itemLocalState={itemLocalState}
                        setItemLocalState={setItemLocalState}
                        disabled={disabled}
                        formatOptions={formatOptions}
                        selected={itemLocalState?.settings?.format}
                        index={index}
                        update={onSettingsChange}
                    />
                </DisplaySettingsWrapper>
            </div>
        </Fragment>
    );
};
EmailFieldItemEdit.displayName = "EmailFieldItemEdit";
export { EmailFieldItemEdit };
